import usePlaygroundMode from '@/util/hooks/queries/usePlaygroundMode';

/**
 * Whether the QA Playground demo chrome (#9141: role switcher, LIVE DEMO pill, walkthrough
 * rail) should render. Same rule as PlaygroundModeBanner: only while Playground is confirmed
 * ON, and never once the env gate is confirmed off (a stale `isActive` survives a 404).
 */
const usePlaygroundDemoChromeVisible = () => {
  const { isActive, isUnavailable } = usePlaygroundMode();
  return isActive && !isUnavailable;
};

export default usePlaygroundDemoChromeVisible;
